require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-crm-developer-bengaluru.json") })
        }
      }, "path---careers-crm-developer-bengaluru");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-crm-developer-bengaluru!./.cache/json/careers-crm-developer-bengaluru.json
// module id = 854
// module chunks = 231608221292675